import React from 'react';
import HeaderLayout from './HeaderLayout';
import './HeaderLayoutCheckoutSuccess.scss';

export default function HeaderLayoutCheckoutSuccess(props) {
  return (
    <React.Fragment>
      <HeaderLayout
        {...props}
        layoutClassName="Layout--Header--CheckoutSuccess"
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderLayout/HeaderLayoutCheckoutSuccess.jsx